import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import Error from './components/Error/Error';
import Login from './components/Login/Login';
import Signup from './components/Signup/Signup';
import Services from './components/Services/Services';
import About from './components/About/About';
import Faq from './components/Faq/Faq';
import Contact from './components/Contact/Contact';

function App() {
  return (
    <div className="App">
      <Router>
        <Header></Header>
        <Switch>
          <Route exact path='/'>
            <Home></Home>
          </Route>
          <Route path='/home'>
            <Home></Home>
          </Route>
          <Route path='/courses'>
            <Services></Services>
          </Route>
          <Route path='/about'>
            <About></About>
          </Route>

          <Route path='/faq'>
            <Faq></Faq>
          </Route>

          <Route path='/contact'>
            <Contact></Contact>
          </Route>

          <Route path='/login'>
            <Login></Login>
          </Route>
          <Route path='/signup'>
            <Signup></Signup>
          </Route>
          <Route path='*'>
            <Error></Error>
          </Route>

        </Switch>
      </Router>
      <Footer></Footer>

    </div>
  );
}

export default App;
